/* global window */
/* eslint react/no-danger: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import css from '../index.scss';
import Button from '../../button/index';
import { DARK } from '../../button/variants';
import messages from '../messages';
import ExtendTable from '../../../components/extend-result-table/index';
import ExtendResultsSuccess from '../modals/success';
import ExtendResultsFailure from '../modals/failure';
import PortalCommunication from '../../../portal-comms';

const ExtendResultForm = (props) => {
    const {
        closeFailureModal,
        extendResults,
        onShowExtendResultInfo,
        extendResultForm,
        isExtending,
        isFail,
        isSuccess,
        yearGroups,
        yearGroupsToBeExtended,
        product
    } = props;

    const onTableChange = (value) => {
        const { setIdsToExtend } = props;
        setIdsToExtend(value);
    };

    const onProceed = () => {
        const { id } = product;
        extendResults(id, yearGroupsToBeExtended);
    };

    const extendTableProps = {
        onChange: onTableChange,
        yearGroups
    };

    const infoView = extendResultForm ? (<div className={css.extendFormComponent}>
        <div className={css.extendFormHeader}>
            {props.intl.formatMessage(messages.formHeader)}
        </div>
        <div className={css.extendFormContent}>
            <div className={css.extendFormContentWrapper}>
                <div className={css.extendFormContentLabels}>
                    <div className={css.extendFormContentWarning}>
                        {props.intl.formatMessage(messages.formContent1)}
                    </div>
                    <div>{props.intl.formatMessage(messages.formContent2)}</div>
                    <div>{props.intl.formatMessage(messages.formContent3)}</div>
                </div>
                <ExtendTable {...extendTableProps} />
            </div>
        </div>
        <div className={css.extendFormFooter}>
            <Button
                containerClassName="continue-button"
                disabled={isExtending}
                handleOnClick={onProceed}
                label={props.intl.formatMessage(messages.formContinueBtn)}
                variant={DARK} />
            <Button
                containerClassName="help-button"
                handleOnClick={onShowExtendResultInfo}
                label={props.intl.formatMessage(messages.formHelpBtn)}
                variant={DARK} />
        </div>
        <ExtendResultsSuccess
            extendedYearGroups={yearGroupsToBeExtended}
            handleOnClick={() => { PortalCommunication.navigateToLandingScreen('Rollover'); }}
            isActive={isSuccess} />
        <ExtendResultsFailure handleOnClick={closeFailureModal} isActive={isFail} />
    </div>) : <div />;

    return infoView;
};

ExtendResultForm.propTypes = {
    intl: intlShape.isRequired,
    closeFailureModal: PropTypes.func,
    extendResultForm: PropTypes.bool,
    isFail: PropTypes.bool,
    isSuccess: PropTypes.bool,
    onShowExtendResultInfo: PropTypes.func,
    setIdsToExtend: PropTypes.func,
    yearGroups: PropTypes.arrayOf(PropTypes.object),
    yearGroupsToBeExtended: PropTypes.object
};

export default injectIntl(styleable(css)(ExtendResultForm));



// WEBPACK FOOTER //
// ./app/components/extend-result/pages/extend-form.js